/* "Continue shopping" — 마지막으로 본 컬렉션으로 돌아간다 (2026-10-06 클라이언트 요청)

   요청: 장바구니 페이지 · 상세에서 Add to cart 뒤 뜨는 팝업의 Continue shopping 이
         `/collections/all` 로만 갔다. 직전에 컬렉션을 보고 왔으면 그 컬렉션으로,
         아니면 `/collections/sunglasses` 로 가게 한다.

   ⚠️⚠️ **브라우저는 방문 기록 목록을 스크립트에 주지 않는다.** 그래서 컬렉션 페이지를 볼 때마다
      그 주소를 sessionStorage(탭 단위)에 적어 두고, 버튼은 그 값을 쓴다.
      즉 기준은 "바로 직전 페이지"가 아니라 **"이 탭에서 마지막으로 본 컬렉션"** 이다
      (컬렉션 → 상품 A → 상품 B → 장바구니 여도 그 컬렉션으로 간다).
   ⚠️ 그 컬렉션이 **바로 직전 페이지**면 링크로 가지 않고 `history.back()` 한다 — 뒤로가기로 돌아가야
      무한 스크롤 위치 복원(`snippets/neoteria-infinite-restore.liquid`, back_forward 일 때만 동작)이
      살아서 고객이 보던 자리로 돌아간다. 링크로 가면 맨 위 1쪽부터 다시 시작한다.
   ⚠️ 저장하는 값은 경로 + 쿼리(필터·정렬 포함)다. 언어 접두어(`/de/collections/…`)도 그대로 둔다.
   ⚠️ 기본 목적지(`/collections/sunglasses`, 언어 접두어 포함)는 Liquid 가 버튼 `href` 에 넣어 둔다 —
      저장값이 없거나 스크립트가 실패해도 그 링크로 간다.

   쓰는 곳: `a[data-nt-continue-shopping]`
     · sections/main-cart-items.liquid (장바구니 상단 · 빈 장바구니)
     · snippets/cart-notification.liquid (Add to cart 팝업)
     · snippets/cart-drawer.liquid (지금은 cart_type 이 notification 이라 안 쓰이지만 맞춰 둔다) */
(() => {
  var KEY = 'nt-last-collection';
  /* `/collections/x` · `/de/collections/x` · `/pt-pt/collections/x`. 컬렉션 안의 상품 주소
     (`/collections/x/products/y`)는 컬렉션 페이지가 아니므로 뺀다. */
  var COLLECTION = /^(\/[a-z]{2}(-[a-z]{2,4})?)?\/collections\/[^/]+\/?$/i;

  function read() {
    try { return sessionStorage.getItem(KEY); } catch (e) { return null; }
  }

  if (COLLECTION.test(location.pathname)) {
    try { sessionStorage.setItem(KEY, location.pathname + location.search); } catch (e) {}
  }

  function previousPage() {
    if (!document.referrer) return null;
    try {
      var r = new URL(document.referrer);
      return r.origin === location.origin ? r.pathname + r.search : null;
    } catch (e) {
      return null;
    }
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[data-nt-continue-shopping]');
    if (!link) return;
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var saved = read();
    if (!saved) return; /* 기본 href(sunglasses)로 간다 */

    event.preventDefault();
    if (previousPage() === saved && history.length > 1) {
      history.back();
    } else {
      location.href = saved;
    }
  });
})();
